module.exports = __webpack_public_path__ + "img/34200.f904206f.jpg";